import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      scholae: [],
      reference: null,
      initial: {
        key: null,
        name: null,
        address2: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        phone: null,
        web: null,
        schools: {},
        createdAt: null,
        updatedAt: null
      }
    }
  },
  getters: {
    scholae (state) {
      return state.scholae
    },
    reference (state) {
      return state.reference
    },
    initial (state) {
      return state.initial
    }
  },
  mutations: {
    init (state, payload) {
      state.scholae = payload
    },
    add (state, payload) {
      state.scholae.push(payload)
    },
    update (state, payload) {
      const index = state.scholae.findIndex(schola => schola.key === payload.key)
      if (index !== -1) {
        Vue.set(state.scholae, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.scholae.findIndex(schola => schola.key === payload.key)
      if (index !== -1) {
        state.scholae.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }, payload) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('scholae')
        var reference = null
        if (payload) {
          reference = dbRef.where('schools.' + payload, '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        } else {
          reference = dbRef.onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        }
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['scholae/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var ref = null
        if (payload.key) {
          ref = db.collection('scholae').doc(payload.key)
        } else {
          ref = db.collection('scholae').doc()
          payload.key = ref.id
        }
        ref.set(payload)
          .then(function () {
            console.log('Document successfully written!')
            resolve(ref.id)
          })
          .catch(function (error) {
            console.error('Error writing document: ', error)
            resolve()
          })
      })
    },
    delete ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        db.collection('scholae').doc(payload).delete().then(function () {
          console.log('Document successfully deleted!')
          resolve()
        }).catch(function (error) {
          console.error('Error removing document: ', error)
          resolve()
        })
      })
    }
  }
}
